/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({

  templateUrl: './customSnackBar.component.html',
})
export class CustomSnackBarComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) { }

}

